import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BACKEND_URL } from '@/config';
import { PageHeader } from '@/components/design';
import { frDate } from '@/utils/currencyUtils';
import { TERMS_SECTIONS, TERMS_VERSION } from '@/content/conditionsGenerales';
import '@/styles/legal.css';

const API = `${BACKEND_URL}/api`;

/**
 * Conditions générales (C8, partie 3c) — `/conditions`, publique. Le texte est `content/conditionsGenerales.js` ;
 * l'éditeur (mentions légales) et l'état du texte (projet pas encore relu) viennent de `GET /public/legal`.
 */
export default function TermsPage() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/legal`).then((r) => setInfo(r.data)).catch(() => setInfo({}));
  }, []);

  const legal = info?.legal;
  return (
    <main className="lgl-page">
      <Link to="/" className="lgl-back"><ArrowLeft size={16} aria-hidden="true" /> Accueil</Link>
      <PageHeader title="Conditions générales d’utilisation" subtitle={`Version du ${frDate(TERMS_VERSION)}`} />

      {info?.terms_draft !== false && (
        <p className="lgl-draft" data-testid="terms-draft">
          Projet de conditions générales, en attente de relecture par un juriste.
        </p>
      )}

      <article className="lgl-text" data-testid="terms">
        {TERMS_SECTIONS.map((s) => (
          <section key={s.title}>
            <h2>{s.title}</h2>
            {s.paragraphs.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
          </section>
        ))}
      </article>

      <footer className="lgl-editor" data-testid="terms-editor">
        <h2>Éditeur</h2>
        {legal ? (
          <>
            <p>{legal.name} · {legal.address} · SIRET {legal.siret}</p>
            {legal.demo && <p className="lgl-demo">Mentions de démonstration.</p>}
          </>
        ) : (
          <p>Mentions légales en cours de publication.</p>
        )}
      </footer>
    </main>
  );
}
